import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { SelectFilterInputProps } from '~/components/ApplicationReports/types.ts';

interface SelectFilterProps extends Pick<SelectFilterInputProps, 'item' | 'applyValue'> {
  options: TAutocompleteOption[];
  labelId?: string;
}

export const FilterComponent = ({
  item,
  applyValue,
  options,
  labelId = 'select-filter-label',
}: SelectFilterProps) => {
  const handleChange = (event: SelectChangeEvent) => {
    applyValue({ ...item, value: event.target.value || null });
  };

  return (
    <Box sx={{ minWidth: 150 }}>
      <FormControl fullWidth size="small">
        <InputLabel id={labelId}>Обрати</InputLabel>
        <Select labelId={labelId} value={item.value || ''} label="Обрати" onChange={handleChange}>
          {options.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
